<template>
    <div class="container my-5">
        <dl class="row">
            <dt class="col-sm-6 col-12"><h3 class="text-dark-green my-2"><i class="fas fa-fire"></i> Promotion Plans Comparison</h3></dt>
            <dd class="col-sm-6 col-12 text-right"><router-link to="/shop/promotions" class="btn btn-light bg-silver">&lt;&lt; Go Back</router-link></dd>
        </dl>
        <table class="table">
            <thead class="thead-light">
                <tr>
                <th scope="col">S/N</th>
                <th scope="col">Features</th>
                <th scope="col">STSPLAN</th>
                <th scope="col">BMPPLAN</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row" class="bg-light">1.</th>
                    <td class="bg-light">Plans Name</td>
                    <td>Status Plan</td>
                    <td>Bump Plan</td>
                </tr>
                <tr>
                    <th scope="row" class="bg-light">2.</th>
                    <td class="bg-light">Another Plus</td>
                    <td><i class="fas fa-times"></i></td>
                    <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                    <th scope="row" class="bg-light">3.</th>
                    <td class="bg-light">Yet another</td>
                    <td><i class="fas fa-times"></i></td>
                    <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                    <th scope="row" class="bg-light"></th>
                    <td class="bg-light"></td>
                    <td><button class="btn btn-warning">Buy</button></td>
                    <td><button class="btn btn-warning">Buy</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "PromotionPlans",
    created() {
        this.$emit('update:layout', LayoutUser);
    }
}
</script>